import styled from 'styled-components';
import { Radius } from 'styles/Global/objectStyles';
import DescriptionContainer from './DescriptionContainer';
import { Accent, BackgroundColor } from 'styles/Global/colorSemantic';
import _ from 'lodash';
import { Body5SemiBold } from 'styles/Global/typography';

type Colors = {
    containerBgc: string;
    badgeBgc: string;
    badgeTextColor: string;
};

export default function AssessmentCard({ target, englishTitle, koreanTitle, description }: { target: string; englishTitle: string; koreanTitle: string; description: string }) {
    const isParent = _.startsWith(target, '부모용');
    const isParentReport = _.startsWith(target, '부모보고용');

    const assessmentColors = function (): Colors {
        if (isParent) {
            return { containerBgc: BackgroundColor.color_backgroud_purple, badgeBgc: Accent.color_accent_purple_weak, badgeTextColor: Accent.color_accent_purple_heavy };
        } else if (isParentReport) {
            return { containerBgc: BackgroundColor.color_backgroud_cyan, badgeBgc: Accent.color_accent_cyan_weak, badgeTextColor: Accent.color_accent_cyan_heavy };
        } else {
            return { containerBgc: BackgroundColor.color_backgroud_lime, badgeBgc: Accent.color_accent_lime_weak, badgeTextColor: Accent.color_accent_lime_heavy };
        }
    };
    return (
        <Container>
            <ContainerHeader $color={assessmentColors()}>
                <Badge $color={assessmentColors()}>
                    <Body5SemiBold $color={assessmentColors().badgeTextColor}>{target}</Body5SemiBold>
                </Badge>
                <TitleWrapper>
                    <Title>{englishTitle}</Title>
                    <SubTitle>{koreanTitle}</SubTitle>
                </TitleWrapper>
            </ContainerHeader>
            <DescriptionContainer description={description} padding='24px 8px' />
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 12px;
    padding: 0px 16px;
    font-family: 'Pretendard', sans-serif;
`;

const ContainerHeader = styled.div<{ $isParent?: boolean; $color?: Colors }>`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;
    gap: 8px;
    padding: 14px 18px;
    background-color: ${(props) => props.$color?.containerBgc};
    border-radius: ${Radius.radius_12};
`;

const Badge = styled.span<{ $isParent?: boolean; $color?: Colors }>`
    display: inline-block;
    background: ${(props) => props.$color?.badgeBgc};
    font-size: 14px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 999px;
    margin-bottom: 8px;
`;

const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const Title = styled.h2`
    font-size: 20px;
    font-weight: 700;
    margin: 0;
`;

const SubTitle = styled.span`
    font-size: 16px;
    font-weight: 500;
    color: #444;
`;

const Description = styled.p`
    font-size: 15px;
    line-height: 1.6;
    padding: 16px 0px;
    color: #333;
`;
